export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (`${time}`.length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a')
      return ['일', '이', '삼', '사', '오', '육', '일'][value - 1]
    if (result.length > 0 && value < 10) {
      value = `0${value}`
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '방금'
  }
  if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}분전`
  }
  if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}시간전`
  }
  if (diff < 3600 * 24 * 2) {
    return '1일전'
  }
  if (option) {
    return parseTime(time, option)
  }
  return `${d.getMonth() +
    1}월${d.getDate()}일${d.getHours()}시${d.getMinutes()}분`
}

// 천자리에 콤마추가
export function setComma(money) {
  const strMoney = `${money}`

  return strMoney.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
}

// 콤마 삭제
export function delComma(money) {
  const strMoney = `${money}`

  return strMoney.trim().replace(/[^\d]+/g, '')
}

// 음수인지 양수인지 ture = 양수, false = 음수
export function setPositive(money) {
  const strMoney = `${money}`
  return strMoney >= 0
}

export function loadImage(image) {
  // eslint-disable-next-line no-undef
  return image && require(`@/assets/images/${image}`)
}



// WEBPACK FOOTER //
// ./src/utils/index.js